function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 20,
  fill: "#0A648F"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M28.7071 13.2929C29.0976 13.6834 29.0976 14.3166 28.7071 14.7071L17.7071 25.7071C17.3166 26.0976 16.6834 26.0976 16.2929 25.7071L11.2929 20.7071C10.9024 20.3166 10.9024 19.6834 11.2929 19.2929C11.6834 18.9024 12.3166 18.9024 12.7071 19.2929L17 23.5858L27.2929 13.2929C27.6834 12.9024 28.3166 12.9024 28.7071 13.2929Z",
  fill: "white"
});

const SvgDoneBadge = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 40,
  height: 40,
  viewBox: "0 0 40 40",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDoneBadge, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/done-badge.d821413d.svg";
export { ForwardRef as ReactComponent };